<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->

                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <!--Name-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="name" placeholder="Enter Name" v-model="name" @keydown="nameKeydown($event)">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{nameError}}</span>
                            </div>
                        </div>

                        <!--Slug-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Slug :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input readonly="readonly" @input="slugError = ''" class="form-control" placeholder="Enter Slug" v-model="slug">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{slugError}}</span>
                            </div>
                        </div>

                        <div class="clearfix"></div>
                        <!--Background Color-->
                        <div class="col-6 input-group">
                            <div class="col-5 paddingleft0">
                                <div class="form-label">Background Color :</div>
                            </div>
                            <div class="col-7 paddingleft0">
                                <ejs-colorpicker v-model="classBackgroundColor"></ejs-colorpicker>
                            </div>
                        </div>

                        <!--Text Color-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Text Color :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <ejs-colorpicker v-model="classTextColor"></ejs-colorpicker>
                            </div>
                        </div>

                    </div>

                    <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>

                    <div class="clearfix"></div>
                    <div class="row no-margin">
                        <div class="col-12 forms-block">
                            <button class="btn btn-success" @click="addGalleryRow"> <i class="fa fa-plus" aria-hidden="false"></i> </button>
                            <span>Click to Add More</span>
                            <span style="margin-left:25px">
                                <span class="help is-danger">{{commonGalleryError}}</span>
                            </span>
                        </div>
                            <div class="clearfix"></div>

                            <template v-for="(input, index) in gallery_inputs">
                                <!-- {{input}}-{{index}} -->
                                <!-- <div class="col-1 forms-block">
                                    <button class="btn btn-danger" @click="deleteGalleryRow(index)"><i class="fa fa-times"></i></button>
                                </div> -->

                                <div class="col-12 forms-block d-flex justify-content-between">
                                    <div class="col-3">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label" for="Name" slot="before">Name :</div>
                                        </div>
                                        <div class="col-12 paddingleft0">
                                            <input @input="commonGalleryError = ''" class="form-control" id="name" placeholder="Name" v-model="input.name">
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label" for="description" slot="before">Description :</div>
                                        </div>
                                        <div class="col-12 paddingleft0">
                                            <input @input="commonGalleryError = ''" class="form-control" id="description" placeholder="Description" v-model="input.description">
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label" for="startDate" slot="before">File :</div>
                                        </div>
                                        <div class="col-12 paddingleft0">
                                            <vue-dropzone
                                                id="drop1"
                                                :options="dropzoneOptions"
                                                :ref="'dropzone_' + index"
                                                :destroyDropzone="false"
                                                :headers="dropzoneOptions.headers"
                                                @vdropzone-total-upload-progress="progressOfUload"
                                                @vdropzone-removed-file="removedSelectedFile(index)"
                                                @vdropzone-success="vfileSuccess"
                                                @vdropzone-complete="afterComplete(index)"
                                                @vdropzone-duplicate-file="vduplicateFile"
                                                name="file[]"
                                            >
                                            <div class="dropzone-custom-content">
                                                <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                                <div class="subtitle">Select files from your computer.</div>
                                            </div>
                                        </vue-dropzone>
                                        <div class="requiredstar">*</div>
                                        </div>
                                    </div>
                                    <div class="col-1 forms-block">
                                        <button class="btn btn-danger" @click="deleteGalleryRow(index)"><i class="fa fa-times"></i></button>
                                    </div>
                                </div>
                            </template>
                            <div class="clearfix"></div>
                            <div class="col-md-2 forms-block">
                            </div>


                    
                    </div>
                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary" v-on:click.prevent="addUpdateClassMaster()">
                        <input id="addAndContinueBenifitBtn" :disabled="disableButtons.saveAndContinue" type="submit" :value="buttonNames.saveAndContinue" class="btn btn-primary" v-on:click.prevent="addUpdateClassMaster (flag='Save and Continue')">
                        <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateClassMaster ()"></input>-->
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary" v-on:click.prevent="buttonBack">
                    </div>
                    <template v-if="gallery_data.length > 0">
                    <div class="row clearfix"></div>
                    <div class="col-md-12 forms-block"></div>
                    <h1 style="text-align:center;">Already Uploaded Media</h1>
                    <div class="row mt-3">
                        <div class="col-md-3">
                            <div class="form-group bold">
                                Name
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group bold">
                                Description
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group bold text-center">
                                Media
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group bold text-center">
                                Action
                            </div>
                        </div>
                    </div>
                    <template v-for="(media,index) in gallery_data">
                        <div class="row bulletin-board-listing">
                            <div class="col-md-3">
                                <div class="form-group">
                                    {{media.name}}
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    {{media.description}} 
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group text-center">
                                    <template  v-if="media.content_type === 'image/jpeg' || media.content_type === 'image/png' || media.content_type === 'image/gif'">
                                        <img width="100%" :src="s3_url+media.path" alt="Maia Parsons" height="150px;">
                                    </template>
                                    <template  v-else-if="media.content_type === 'video/mp4'">
                                        <video width="100%" controls="controls" preload="metadata">
                                            <template  v-if="media.path != ''">
                                                <source :src="s3_url+media.path+'#t=0.5'"  type="video/mp4">
                                            </template>
                                            <template  v-else>
                                                <source src="" type="video/mp4">
                                            </template>
                                            </video>
                                    </template>
                                    <template  v-else>
                                        <a :href="s3_url+media.path" download>Download</a>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group text-center"><button :id="media.id" @click="removeGalleryMedia(media.id)" type="button" class="btn btn-primary" style="margin-top: 30px;"><i class="fa fa-minus-circle"></i></button></div>
                            </div>
                        </div>
                    </template>
                    </template>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import Swal from 'sweetalert2';
    import { ColorPickerPlugin } from '@syncfusion/ej2-vue-inputs';
    Vue.use(ColorPickerPlugin);
    import {frontDomain,ssoDomain,s3_bucket_url} from '../../config'

    var moment = require('moment-timezone');

    export default {
        name: 'addUpdateClassMaster',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
            'vueDropzone': vue2Dropzone,
        },
        data() {
            return {
                s3_url:'https://vtemp-bucket.s3.us-west-2.amazonaws.com/',
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: "POST",
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 250, //MB
                    dictFileTooBig: "File is to big ({{filesize}}MB). Max allowed file size is {{maxFilesize}}MB",
                    thumbnailWidth: 150, //px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    dictCancelUpload: 'Cancel',
                    dictRemoveFile: "Remove",
                    acceptedFiles: ".jpg, .jpeg, .png,.pdf,.doc,.mp4",
                    maxFiles: 1,
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    }
                },
                pageTitle : "Add Class",

                name : '',
                nameError : "",

                docType: '',
                docSize: '',
                docPaths: '',
                isFileUploaded: false,
                fileUploaded: true,
                isDocLoaded: false,

                allPermissions : [],
                checkedPermissions : [],

                buttonNames : {
                    save : 'Save',
                    saveAndContinue : 'Save And Continue',
                    cancel : 'Cancel'
                },
                disableButtons : {
                    save : false,
                    saveAndContinue : false,
                    cancel : false
                },
                alertClass : '',
                alertMessage : '',
                permissionRendered : false,
                gallery_inputs: [
                    // {
                    //         name: "",
                    //         description : "",
                    //         files:""
                    //     }
                ],
                commonGalleryError:"",
                gallery_data: [],
                classBackgroundColor: '',
                classTextColor: '',
                slug : "",
                slugError : "",
                classId : "",
                firstAdd : false,
                maxLimitOfUploadFile : 5,
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "listclassmasterinfo");
        },

        mounted: function () {
            self.firstAdd = true;
            // EventBus.$emit('showHeader', true);
            $("#alertError").hide();

            self.classBackgroundColor = "#3a87ad";
            self.classTextColor = "#FFFFFF";
            self.s3_url = s3_bucket_url;
            /* Remove error on input */
            $("#name").keyup(function () {
                self.nameError = "";
            });


            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[1] == 'update-class-master') {
                if (segments[2]) {
                    self.getClassDetailById();
                    self.buttonNames.save = "Update";
                    $("#addAndContinueBenifitBtn").hide();
                    self.pageTitle = "Edit Class";
                }
            }
        },
        beforeDestroy(){
            // EventBus.$off('all-permissions');
        },
        watch : {
            name :function (value) {
                //self.name = value.replace(/\W/g, "")
                self.slug = value.toLowerCase();
                // if (self.slug.includes(" ")) {
                //     self.slug = self.slug.split(' ').join('-');
                // }
                self.slug = self.slug.replace(/\W/g, "");//do not allow special character
            },
            slug : function (value) {
                self.checkSlug(value);
            },
        },
        methods: {
            nameKeydown(e) {
                // if (/^\W$/.test(e.key)) {
                //     e.preventDefault();
                // }
            },
            
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                self.disableButtons.save = true;
                self.disableButtons.saveAndContinue = true;
                self.disableButtons.cancel = true;
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.videoURLError = "";
                    self.disableButtons.save = false;
                    self.disableButtons.saveAndContinue = false;
                    self.disableButtons.cancel = false;
                } else {
                    self.fileUploaded = false;
                }
            },
            checkSlug : function (value) {
                self.slugError = "";
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                var path = window.location.pathname;
                var segments = path.split("/");
                var addOrUpdate = "";
                if (segments[1] === 'update-class-master') {
                    if (segments[2]) {
                        addOrUpdate = "update";
                    }
                    var  data = {
                        slug_value : value,
                        add_or_update : addOrUpdate,
                        class_id : self.classId,
                    };
                } else {
                    addOrUpdate = "add";
                    var  data = {
                        slug_value : value,
                        add_or_update : addOrUpdate,
                        class_id : 0,
                    };
                }
                HTTP.post('class/checkslug', data, config)
                    .then(function (response) {
                        if (response.status == 201) {
                            self.slugError = response.data.message;
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            deleteGalleryRow(index) {
                self.gallery_inputs.splice(index,1);
                self.commonGalleryError = "";
            },
            addGalleryRow() {
                if((self.gallery_inputs.length + 1) > self.maxLimitOfUploadFile){
                    self.commonGalleryError = "You can upload max " + self.maxLimitOfUploadFile +" media same time";
                    return;
                } else {
                    if (self.firstAdd) {
                        self.gallery_inputs.push({
                            name: "",
                            description : "",
                            file : "",
                        });
                        self.firstAdd = false;
                    } else {
                        if (self.checkGalleryInput()) {
                            self.gallery_inputs.push({
                                name: "",
                                description : "",
                                file : "",
                            });
                        } else {
                            self.commonGalleryError = "Please fill all the details";
                        }
                    }
                }
            },
            checkGalleryInput: function () {
                var checked = true;
                for (let i = 0; i < self.gallery_inputs.length; i++) {
                        if (self.gallery_inputs[i].name === "" || self.gallery_inputs[i].name === null || typeof self.gallery_inputs[i].name === "undefined") {
                            self.commonGalleryError = "Please fill all the details";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (self.gallery_inputs[i].description === "" || self.gallery_inputs[i].description === null || typeof self.gallery_inputs[i].description === "undefined") {
                            self.commonGalleryError = "Please fill all the details";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (self.gallery_inputs[i].files === "" || self.gallery_inputs[i].files === null || typeof self.gallery_inputs[i].files === "undefined") {
                            self.commonGalleryError = "Please fill all the details";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }


                return checked;

            },
            showAlertOnSave : function (alertMessage, alertType) {
                if (alertType === "success") {
                    self.alertClass = "alert alert-success";
                } else {
                    self.alertClass = "alert alert-danger";
                }
                self.alertMessage = alertMessage;
                $("#success-alert").fadeTo(3000, 500).slideUp(500, function(){
                    $("#success-alert").slideUp(500);
                });
            },
            buttonBack : function () {
                self.$router.push('/class-master/list');
            },
            removedSelectedFile(index,file, xhr, error) {
                self.gallery_inputs[index].files = "";
            },
            removeGalleryMedia: function (id) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        id: id,
                    }
                };
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't to delete this media!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes!'
                    }).then((result) => {
                    if (result.value == true) {
                HTTP.delete('removemedia/class/gallery', config)
                    .then(function (response) {
                        self.gallery_data = response.data.class.gallery_media;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
                    }
                });
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia/public', config)
                    .then(function (response) {
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },

            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },
            afterComplete(index){
                var file_obj = {
                    docPaths:self.docPaths,
                    docType:self.docType,
                    docSize:self.docSize,
                }

                self.gallery_inputs[index].files = file_obj

                self.docPaths = '';
                self.docType = '';
                self.docSize = '';

            },
            vfileSuccess: function (file, response) {
                self.docPaths = response.content.media_path;
                self.docType = file.type;
                self.docSize = file.size;
                self.commonGalleryError = "";
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.

            },
            removeAllFiles: function () {
                this.$refs.dropzone_0[0].removeAllFiles();
                for (let i = 0; i < self.gallery_inputs.lenght; i++) {
                    this.$refs.dropzone_+i[0].removeAllFiles();
                }
            },

            clearDataOnSaveAndContinue : function () {
                self.name = '';
                self.classBackgroundColor = "#3a87ad";
                self.classTextColor = "#FFFFFF";
                self.firstAdd = true;
                /*self.gallery_inputs = {
                    name: "",
                    description : "",
                    file : "",
                };*/
                /*self.gallery_inputs.push({
                    name: "",
                    description : "",
                    file : "",
                });*/
                self.addGalleryRow();
                self.removeAllFiles();
            },


            checkForm: function () {
                var checked = true;
                if (!self.checkGalleryInput()) {
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.name) {
                    self.nameError = "Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.slug) {
                    self.slugError = "Slug Required";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },

            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },


            getClassDetailById: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    id: segments[2],
                };

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.post('/class-master/by-id', fields, config).
                then(response => {
                    self.classId = response.data.class.id;
                    self.name = response.data.class.name;
                    self.gallery_data = response.data.class.gallery_media;
                    self.slug = response.data.class.slug;
                    self.classBackgroundColor = response.data.class.background_color;
                    self.classTextColor= response.data.class.text_color;
                })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                        }
                    });
            },

            addUpdateClassMaster (flag) {
                setTimeout(() => {
                    self.checkForm();
                    if (self.checkForm()) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var config = {
                            headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                        };

                        if (segments[1] == 'update-class-master') {
                            if (segments[2]) {
                                var data = {
                                    name: self.name,
                                    gallery_inputs:self.gallery_inputs,
                                    mediaPath: self.docPaths,
                                    id: self.classId,
                                    class_background_color : self.classBackgroundColor,
                                    class_text_color : self.classTextColor,
                                    slug : self.slug,
                                };
                                self.buttonNames.save = "Updating ...";
                                self.disableButtons.save = true;
                                self.disableButtons.cancel = true;
                            } else {
                                if (flag == "Save and Continue") {
                                    self.buttonNames.saveAndContinue = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                } else {
                                    self.buttonNames.save = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                }
                            }
                        } else {
                            var data = {
                                name: self.name,
                                mediaPath: self.docPaths,
                                gallery_inputs:self.gallery_inputs,
                                class_background_color : self.classBackgroundColor,
                                class_text_color : self.classTextColor,
                                slug : self.slug,
                            };
                            if (flag == "Save and Continue") {
                                self.buttonNames.saveAndContinue = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true
                            } else {
                                self.buttonNames.save = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true;
                            }
                        }

                        HTTP.post("/class-master/add", data, config)
                            .then(function (response) {
                                self.commonGalleryError = "";
                                if(response.status == 201){
                                    if(response.data.content.name[0] != undefined && response.data.content.name[0]!= ''){
                                        self.nameError = response.data.content.name[0];
                                    }
                                    //return false;
                                }
                                EventBus.$emit('change_sidebar_menu', false, response.data.content);
                                if (segments[1] == 'update-class-master') {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    if (segments[2]) {
                                        self.buttonNames.save = "Update";
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                        } else {
                                            self.buttonNames.save = "Save";
                                        }
                                    }
                                } else {
                                    self.gallery_inputs = [];
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                    } else {
                                        self.buttonNames.save = "Save";
                                    }
                                }
                                if (response.data.status == "success") {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    EventBus.$emit('succes-message', response.data.message);
                                    //self.showAlertOnSave(response.data.message, "success");
                                    self.showSAlert(response.data.message,'success',false);
                                    if (flag == "Save and Continue") {
                                        self.clearDataOnSaveAndContinue();
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                    } else {
                                        setTimeout(function () {
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    self.disableButtons.save = false;
                                    self.disableButtons.saveAndContinue = false;
                                    self.disableButtons.cancel = false;
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i];
                                        }
                                        EventBus.$emit('succes-message', err);
                                        self.showAlertOnSave(err, "error");
                                    }
                                }
                            })
                            .catch(function (err) {
                                console.log(err);
                                if (segments[1] == 'update-class-master') {
                                    if (segments[2]) {
                                        self.buttonNames = "Update";
                                        self.disableButtons.save = false;
                                        self.disableButtons.cancel = false;
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                            self.clearDataOnSaveAndContinue();
                                        } else {
                                            self.buttonNames.save = "Save";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                        self.clearDataOnSaveAndContinue();
                                    } else {
                                        self.buttonNames.save = "Save";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }
                                }
                            });
                    }
                }, 200);
            },
        }

    }

    EventBus.$on('all-permissions', function (isLogin, allPermissions) {
        if (typeof (self) != 'undefined') {
            self.allPermissions = [];
            for (var i = 0; i < allPermissions.length; i++) {
                var permissionNameArray = allPermissions[i].name.split("_");
                var permissionName = '';
                var permission = '';

                for (var j = 0; j < permissionNameArray.length; j++) {
                    permission = permissionNameArray[j].charAt(0).toUpperCase() + permissionNameArray[j].slice(1);
                    permissionName = permissionName +  " " + permission;
                }

                self.allPermissions.push({
                    'id' : allPermissions[i].id,
                    'name' : permissionName
                });
            }

            let path = window.location.pathname;
            let segments = path.split('/');

            if (segments[1] === 'update-user') {
                self.getClassDetailById();
            }
            // self.allPermissions = allPermissions;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/ClassMaster/AddUpdateClassMaster.vue